import { RenderableErrorResponse } from '../../../../../services/exports/Types';
import { ERROR_CODES } from '../../../../../services/exports/Constants';
import useOutOfStockErrorHandler from './useOutOfStockErrorHandler';
import useItemsUnavailableErrorHandler from './useItemsUnavailableErrorHandler';

const useOrderErrorHandler = () => {
  const outOfStockErrorHandler = useOutOfStockErrorHandler();
  const itemsUnavailableErrorHandler = useItemsUnavailableErrorHandler();

  const handler = (response: RenderableErrorResponse<any>): void => {
    // A request that never got an answer (offline, timeout, a WebView-aborted fetch) reaches the
    // checkout error paths with no `response`. There is no error code to act on, so it is left to
    // the caller's generic alert — throwing here used to swallow that alert entirely.
    const errorCode = response?.response?.data?.error_code;

    if (errorCode === ERROR_CODES.ITEMS_OUT_OF_STOCK) {
      return outOfStockErrorHandler(response);
    }

    if (errorCode === ERROR_CODES.ITEMS_MENU_TIME_UNAVAILABLE) {
      return itemsUnavailableErrorHandler(response);
    }
  };

  return handler;
};

export default useOrderErrorHandler;
